module.exports = __webpack_public_path__ + "img/copper-vein.ec698fed.png";